type ContentCardProps = {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  contentClassName?: string;
};

export default function ContentCard({
  title,
  subtitle,
  children,
  contentClassName = "",
}: ContentCardProps) {
  return (
    <section className="rounded-lg border border-[#E6EEF2] bg-white p-4 shadow-sm">
      <div className="mb-4">
        <h3 className="text-base font-semibold text-[#2B4752]">{title}</h3>
        {subtitle ? (
          <p className="mt-1 text-sm text-[#7F7F7F]">{subtitle}</p>
        ) : null}
      </div>
      <div className={contentClassName}>{children}</div>
    </section>
  );
}
